import { render, staticRenderFns } from "./EtichetteModal.vue?vue&type=template&id=99e40e9c&scoped=true"
import script from "./EtichetteModal.vue?vue&type=script&lang=js"
export * from "./EtichetteModal.vue?vue&type=script&lang=js"
import style0 from "./EtichetteModal.css?vue&type=style&index=0&id=99e40e9c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e40e9c",
  null
  
)

export default component.exports